/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/DialogFlowTemplateMessageReport', 'model/DialogFlowTemplateMessage'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('../model/DialogFlowTemplateMessageReport'), require('../model/DialogFlowTemplateMessage'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.DialogFlowTemplateMessageApi = factory(root.ForStractionServiceApi.ApiClient, root.ForStractionServiceApi.DialogFlowTemplateMessageReport, root.ForStractionServiceApi.DialogFlowTemplateMessage);
  }
}(this, function(ApiClient, DialogFlowTemplateMessageReport, DialogFlowTemplateMessage) {
  'use strict';

  /**
   * DialogFlowTemplateMessage service.
   * @module api/DialogFlowTemplateMessageApi
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new DialogFlowTemplateMessageApi. 
   * @alias module:api/DialogFlowTemplateMessageApi
   * @class
   * @param {module:ApiClient} apiClient Optional API client implementation to use,
   * default to {@link module:ApiClient#instance} if unspecified.
   */
  var exports = function(apiClient) {
    this.apiClient = apiClient || ApiClient.instance;


    /**
     * Callback function to receive the result of the dialogFlowTemplateMessageAddPut operation.
     * @callback module:api/DialogFlowTemplateMessageApi~dialogFlowTemplateMessageAddPutCallback
     * @param {String} error Error message, if any.
     * @param {'Integer'} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * add
     * @param {String} _4SAPIAppID 
     * @param {module:model/DialogFlowTemplateMessageReport} body 
     * @param {Object} opts Optional parameters
     * @param {Integer} opts.parentMessageID 
     * @param {Integer} opts.parentOptionID 
     * @param {module:api/DialogFlowTemplateMessageApi~dialogFlowTemplateMessageAddPutCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link 'Integer'}
     */
    this.dialogFlowTemplateMessageAddPut = function(_4SAPIAppID, body, opts, callback) {
      opts = opts || {};
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling dialogFlowTemplateMessageAddPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling dialogFlowTemplateMessageAddPut";
      }


      var pathParams = {
      };
      var queryParams = {
        'parentMessageID': opts['parentMessageID'],
        'parentOptionID': opts['parentOptionID']
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = 'Integer';

      return this.apiClient.callApi(
        '/DialogFlowTemplateMessage/add', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the dialogFlowTemplateMessageDeleteGet operation.
     * @callback module:api/DialogFlowTemplateMessageApi~dialogFlowTemplateMessageDeleteGetCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * delete
     * @param {String} _4SAPIAppID 
     * @param {Integer} entityID 
     * @param {module:api/DialogFlowTemplateMessageApi~dialogFlowTemplateMessageDeleteGetCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.dialogFlowTemplateMessageDeleteGet = function(_4SAPIAppID, entityID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling dialogFlowTemplateMessageDeleteGet";
      }

      // verify the required parameter 'entityID' is set
      if (entityID == undefined || entityID == null) {
        throw "Missing the required parameter 'entityID' when calling dialogFlowTemplateMessageDeleteGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'entityID': entityID
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/DialogFlowTemplateMessage/delete', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the dialogFlowTemplateMessageEditAllPut operation.
     * @callback module:api/DialogFlowTemplateMessageApi~dialogFlowTemplateMessageEditAllPutCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * editAll
     * @param {String} _4SAPIAppID 
     * @param {Array.<module:model/DialogFlowTemplateMessage>} body 
     * @param {module:api/DialogFlowTemplateMessageApi~dialogFlowTemplateMessageEditAllPutCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.dialogFlowTemplateMessageEditAllPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling dialogFlowTemplateMessageEditAllPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling dialogFlowTemplateMessageEditAllPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/DialogFlowTemplateMessage/editAll', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the dialogFlowTemplateMessageEditPut operation.
     * @callback module:api/DialogFlowTemplateMessageApi~dialogFlowTemplateMessageEditPutCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * edit
     * @param {String} _4SAPIAppID 
     * @param {module:model/DialogFlowTemplateMessage} body 
     * @param {module:api/DialogFlowTemplateMessageApi~dialogFlowTemplateMessageEditPutCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.dialogFlowTemplateMessageEditPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling dialogFlowTemplateMessageEditPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling dialogFlowTemplateMessageEditPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/DialogFlowTemplateMessage/edit', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the dialogFlowTemplateMessageLoadGet operation.
     * @callback module:api/DialogFlowTemplateMessageApi~dialogFlowTemplateMessageLoadGetCallback
     * @param {String} error Error message, if any.
     * @param {module:model/DialogFlowTemplateMessageReport} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * load
     * @param {String} _4SAPIAppID 
     * @param {Integer} entityID 
     * @param {module:api/DialogFlowTemplateMessageApi~dialogFlowTemplateMessageLoadGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/DialogFlowTemplateMessageReport}
     */
    this.dialogFlowTemplateMessageLoadGet = function(_4SAPIAppID, entityID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling dialogFlowTemplateMessageLoadGet";
      }

      // verify the required parameter 'entityID' is set
      if (entityID == undefined || entityID == null) {
        throw "Missing the required parameter 'entityID' when calling dialogFlowTemplateMessageLoadGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'entityID': entityID
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = DialogFlowTemplateMessageReport;

      return this.apiClient.callApi(
        '/DialogFlowTemplateMessage/load', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
  };

  return exports;
}));
